interface Props {
  message: string | null;
  onClose: () => void;
}

export default function NotificationToast({ message, onClose }: Props) {
  if (!message) return null;

  return (
    <div className="fixed top-4 left-4 right-4 p-4 bg-red-900/95 border border-red-500 rounded-lg flex items-center justify-between z-50">
      <div className="flex items-center gap-3">
        <span className="text-2xl">⚠️</span>
        <span className="text-red-100 font-medium">{message}</span>
      </div>
      <button onClick={onClose} className="text-red-300 hover:text-white">
        ✕
      </button>
    </div>
  );
}
